import { useState, type FormEvent } from "react";
import { recoverAccess } from "../../api/planner";
import { ApiError } from "../../api/client";
import { Button } from "../../components/Button";
import { ErrorSummary } from "../../components/ErrorSummary";

export function RecoveryPage({ online, announce }: { online: boolean; announce: (message: string) => void }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) {
      setErrors({ email: "Enter an email address in the correct format." });
      return;
    }
    setBusy(true); setErrors({});
    try {
      await recoverAccess(email.trim());
      setSent(true); announce("Secure link requested");
    } catch (error) {
      setErrors({ page: error instanceof ApiError ? error.message : "We couldn’t request a new link. Try again." });
    } finally { setBusy(false); }
  };
  if (sent) return (
    <section className="confirmation confirmation--success page--narrow" role="status">
      <p className="eyebrow">Secure link requested</p>
      <h1>Check your email</h1>
      <p>If that address can receive email, we’ll send a secure link shortly. Check your inbox and spam folder.</p>
    </section>
  );
  return (
    <section className="page page--narrow">
      <p className="eyebrow">Plan recovery</p>
      <h1>Email me a new secure link</h1>
      <p className="lede">Use the email address you chose when saving. Our response is the same whether or not a matching plan exists.</p>
      <ErrorSummary errors={errors} />
      <form className="question-card" onSubmit={submit} noValidate>
        <div className={`field ${errors.email ? "field--error" : ""}`}>
          <label htmlFor="email">Email address</label>
          {errors.email && <p className="field-error" id="email-error">{errors.email}</p>}
          <input id="email" type="email" autoComplete="email" value={email} aria-invalid={Boolean(errors.email)} aria-describedby={errors.email ? "email-error" : undefined} onChange={(event) => setEmail(event.target.value)} />
        </div>
        <Button type="submit" busy={busy} disabled={!online}>{busy ? "Sending secure link…" : "Email me a new secure link"}</Button>
      </form>
    </section>
  );
}
